import type { PurchaseType } from '../../types'

/**
 * Customer-facing purchase-type labels for the compact ordering list.
 * Internal API values (PCS / PACK / HALF_PACK) are unchanged — only the
 * display labels differ from the admin/cart labels.
 */
export const CUSTOMER_TYPE_LABELS: Record<PurchaseType, string> = {
  PCS: 'Satuan',
  PACK: '1 Dus / Renteng',
  HALF_PACK: '½ Dus / Renteng',
}
